<app-login>
  <div class="login-title" login-title>
    <app-logo-svg primary-color-light="#000"></app-logo-svg>
    <app-name-svg logo-text-color-light="#000"></app-name-svg>
  </div>
</app-login>
